import React from 'react';
import styles from './ORSMFaqsItem.module.scss';
import { useDisclose } from '../../../Modal/Hooks/useDisclose';
import { joinClasses } from '../../../../Utils/className.util';
import Text from '../../../../Components/Base/Text/Text';

interface Props {
	title: string;
	text: string;
}

const ORSMFaqsItem: React.FC<Props> = ({ title, text }) => {
	const { isOpen, onToggle } = useDisclose(false);

	return (
		<div className={styles.wrapper} onClick={onToggle}>
			<div className={joinClasses([styles.title, isOpen && styles.isOpen])}>
				<Text tx={title} />
			</div>
			{isOpen && <Text className={styles.text} tx={text} />}
		</div>
	);
};

export default ORSMFaqsItem;
